<template>
    <div class="section" :style="styles">
        <v-container :pa-2="$vuetify.breakpoint.smAndDown" :fluid="fluid">
                <h2 v-if="header" class="mt-4">{{header}}</h2>
                <slot/>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "BaseSection",
        props: {
            header: {
                type: String,
                default: null
            },
            background: {
                type: String,
                default: null
            },
            fluid: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            styles() {
                return {
                    backgroundImage: this.background ? `url(${this.background})` : undefined
                };
            }
        },
    };
</script>

<style scoped>
    .section {
        background-position: center center;
        background-size: cover;
    }
</style>